"use strict";

exports.__esModule = true;
exports.isObject = exports.months = exports.range = exports.getYears = exports.getDaysInMonth = void 0;
/**
  * Get the number of days based on the given month
  * @param {number} m - month (0-11)
  * @param {number} y - year (YYYY)
*/

var getDaysInMonth = function getDaysInMonth(m, y) {
  switch (m) {
    case 1:
      return y % 4 === 0 && y % 100 || y % 400 === 0 ? 29 : 28;

    case 3:
    case 5:
    case 8:
    case 10:
      return 30;

    default:
      return 31;
  }
};
/**
 * Pass a number and it return a list of years
 * starting with current year.
 * @param {number} numberOfYears
*/


exports.getDaysInMonth = getDaysInMonth;

var getYears = function getYears(numberOfYears) {
  var currentYear = new Date().getFullYear();
  var list = [];

  for (var i = 0; i < numberOfYears; i += 1) {
    list.push(currentYear);
    currentYear -= 1;
  }

  return list;
};
/**
 * Create an array based on a range of number from
 * one value to another.
 * @param {number} from - Inclusive
 * @param {number} to - Inclusive
*/


exports.getYears = getYears;

var range = function range(from, to) {
  var list = [];

  for (var i = from; i <= to; i += 1) {
    list.push(i);
  }

  return list;
};

exports.range = range;
var months = [{
  label: 'January',
  value: 1
}, {
  label: 'February',
  value: 2
}, {
  label: 'March',
  value: 3
}, {
  label: 'April',
  value: 4
}, {
  label: 'May',
  value: 5
}, {
  label: 'June',
  value: 6
}, {
  label: 'July',
  value: 7
}, {
  label: 'August',
  value: 8
}, {
  label: 'September',
  value: 9
}, {
  label: 'October',
  value: 10
}, {
  label: 'November',
  value: 11
}, {
  label: 'December',
  value: 12
}];
exports.months = months;

var isObject = function isObject(value) {
  return typeof value === 'object' && value !== null;
};

exports.isObject = isObject;